import * as React from 'react'

export function CallTrackingSmallIcon() {
  return (
    <svg
      width="64"
      height="69"
      viewBox="0 0 55 73"
      display="block"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.869 20.94a26.03 26.03 0 1 0 26.028 26.036c0-14.41-11.858-26.036-26.028-26.036Zm0 44.191a17.816 17.816 0 1 1 17.82-17.816c0 9.893-7.872 17.816-17.82 17.816Z"
        fill="#02BDF6"
      />
      <path
        d="M55.475 7.925C47.845 3.124 38.528 0 28.868 0S9.896 3.124 2.26 7.925C.002 9.602-.576 12.72.58 14.982l3.702 6.767c.867 1.389 2.834 1.967 3.99.867 2.257-1.677 4.513-3.412 7.057-4.51a1.566 1.566 0 0 0 .867-1.39V12.72c0-.578.29-1.156.868-1.156 3.701-1.389 7.636-1.967 11.626-1.967h.578c3.991 0 7.926.578 11.627 1.967.578 0 .868.578.868 1.156v3.991c0 .578.289 1.157.867 1.39 2.545 1.156 4.801 2.834 7.058 4.51 1.156 1.157 3.123.579 3.99-.867l3.707-6.761c.925-2.262.404-5.38-1.91-7.057ZM28.868 56.628a9.602 9.602 0 1 0 0-19.204 9.602 9.602 0 0 0 0 19.204Z"
        fill="#02BDF6"
      />
    </svg>
  )
}

export function CallTrackingIcon() {
  return (
    <svg
      width="58"
      height="73"
      viewBox="0 0 58 73"
      display="block"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.869 20.94a26.03 26.03 0 1 0 26.028 26.036c0-14.41-11.858-26.036-26.028-26.036Zm0 44.191a17.816 17.816 0 1 1 17.82-17.816c0 9.893-7.872 17.816-17.82 17.816Z"
        fill="#02BDF6"
      />
      <path
        d="M55.475 7.925C47.845 3.124 38.528 0 28.868 0S9.896 3.124 2.26 7.925C.002 9.602-.576 12.72.58 14.982l3.702 6.767c.867 1.389 2.834 1.967 3.99.867 2.257-1.677 4.513-3.412 7.057-4.51a1.566 1.566 0 0 0 .867-1.39V12.72c0-.578.29-1.156.868-1.156 3.701-1.389 7.636-1.967 11.626-1.967h.578c3.991 0 7.926.578 11.627 1.967.578 0 .868.578.868 1.156v3.991c0 .578.289 1.157.867 1.39 2.545 1.156 4.801 2.834 7.058 4.51 1.156 1.157 3.123.579 3.99-.867l3.707-6.761c.925-2.262.404-5.38-1.91-7.057ZM28.868 56.628a9.602 9.602 0 1 0 0-19.204 9.602 9.602 0 0 0 0 19.204Z"
        fill="#02BDF6"
      />
    </svg>
  )
}
